module.exports = __webpack_public_path__ + "img/chess_chinesechessred2.ab635159.png";